import './Page.css';
import CopyBlock from './CopyBlock';

export default function About() {
  return (
    <div className='page'>
      <h2 className='subheadline-black exception-2'>
        Zostań partnerem akcji
        <br /> "OTWARTE PRACOWNIE NA MAZURACH”
      </h2>
      <div className='page-text'>
        <p>
          <h3 className='subheadline-upper'>
            Prowadzisz restaurację, pensjonat, kawiarnię lub inne miejsce na
            Mazurach?
          </h3>
          <p>Dołącz do wyjątkowej inicjatywy Stowarzyszenia Nasze Talki!</p>
          <p>
            W ramach akcji “Otwarte Pracownie na Mazurach” przygotowujemy mapę
            twórczych miejsc i otwartych pracowni artystów, rzemieślników, którą
            bezpłatnie dystrybuujemy w regionie.
          </p>
          <h3 className='subheadline-upper'>Co oferujemy?</h3>
          <ul>
            W zamian za darowiznę na rzecz stowarzyszenia:
            <li>
              umieścimy Twoją restaurację, pensjonat lub inny punkt na mapie
              Mazur Otwartych Pracowni (w tym roku w wersji online, a przy
              okazji następnej edycji w druku)
            </li>
            <li>oznaczymy Cię jako Miejsce Przyjazne Kulturze,</li>
            <li>
              wspomnimy o Tobie w naszych kanałach social media jako Partnerze
              Wydarzenia.
            </li>
          </ul>
          <h3 className='subheadline-upper'>Dlaczego warto?</h3>
          <ul>
            <li>wspierasz lokalną kulturę i sztukę,</li>
            <li>
              zwiększasz widoczność swojego miejsca wśród turystów i miłośników
              Mazur,
            </li>
            <li>
              pokazujesz, że jesteś częścią wartościowej inicjatywy społecznej.
            </li>
          </ul>
          <h3 className='subheadline-upper'>Jak dołączyć?</h3>
          <p>
            Wystarczy wpłacić dowolną kwotę - “darowiznę na cele statutowe
            Stowarzyszenia Nasze Talki OPM”, a my zajmiemy się resztą. Chcesz
            wiedzieć więcej?
          </p>
          <p>Napisz do nas lub zadzwoń.</p>
          <div className='with-icons'>
            <div>
              <img className='ikona-modal' src='./img/ikona-tel.svg' />
              <a href='tel:784231053'>784 231 053</a>
            </div>
            <div>
              <img className='ikona-modal' src='./img/ikona-mail.svg' />{' '}
              <a href='mailto:grafelinska@gmail.com'>grafelinska@gmail.com</a>
            </div>
          </div>
          <h3 className='subheadline-upper'>
            Dlaczego tak ważne jest by wspierać lokalne działania kulturalne?
          </h3>
          <ul>
            <li>
              Razem możemy wypromować to, co bardzo cenne lecz często ukryte -
              mazurską społeczność o niezwykłym potencjale.
            </li>
          </ul>
          <h3 className='subheadline-upper'>
            Twoje wsparcie to dla nas ogromna motywacja!
          </h3>
          <p>
            Każda, nawet najmniejsza darowizna na cele statutowe Stowarzyszenia
            “Nasze Talki”, pozwala na kontynuowanie naszej pracy na rzecz
            współczesnej mazurskiej kultury: autentycznej, niezależnej i
            dostępnej!
          </p>
          <p>http://naszetalki.pl/ </p>
          <CopyBlock copyText={`BNP PARIBAS`}>
            <p>BNP PARIBAS</p>
          </CopyBlock>
          <CopyBlock copyText={`43 2030 0045 1110 0000 0395 4700`}>
            <p>Numer konta: 43 2030 0045 1110 0000 0395 4700</p>
          </CopyBlock>
          <CopyBlock copyText={`KRS: 0000309985 STOWARZYSZENIE NASZE TALKI`}>
            <p>KRS: 0000309985 STOWARZYSZENIE NASZE TALKI</p>
          </CopyBlock>
          <CopyBlock copyText={`NIP: 8451936699`}>
            <p>NIP: 8451936699</p>
          </CopyBlock>
          <CopyBlock copyText={`REGON: 280328781`}>
            <p>REGON: 280328781</p>
          </CopyBlock>
          <p>
            Projekt realizowany przez Stowarzyszenie „Nasze Talki”, finansowany
            ze środków Gminy Wydminy, Ministerstwa Kultury i Dziedzictwa
            Narodowego w ramach programu „Kultura Dostępna” oraz Funduszu
            Popierania Twórczości ZAiKS.
          </p>
        </p>
      </div>
    </div>
  );
}
